import React, { useEffect, useMemo } from 'react';

import _ from 'lodash';
import cx from 'classnames';

import { WidgetsContext, Widget } from './../core';
import BrandThemeManager from '../../Theme';

import styles from './liveElements.module.scss';

import { LIVE_ELEMENT_CONTAINER } from '../../../constants/widgetTypes';

const LiveElementWidgetComponent = ({ className, style, widgetProps, breakpoint }) => {
  const context = React.useContext(WidgetsContext);

  const id = _.get(widgetProps, 'uid');
  const [widgetContextState, setWidgetContextState] = React.useState({
    ...context,
    ...context.createLiveElementContext(widgetProps)
  });

  useMemo(() => {
    const paths = ['breakpoint', 'imageCDN', 'storyboard'];
    const next = _.pick(context, paths);
    const previous = _.pick(widgetContextState, paths);

    const equals = _.isEqual(next, previous);
    if(!equals){
      setWidgetContextState((state) => {
        return {
          ...state,
          ...next
        }
      });
    }

  }, [context]);

  var widgetChildren = (widgetProps.children || []).filter(item => {
    return item.type === LIVE_ELEMENT_CONTAINER
  });

  return (
    <div id={id}
      className={cx(className, styles.liveElement, 'cs_live_element', {
        [styles.mobile]: breakpoint === 'mobile'
      })}
      data-widget-id={id}
      data-container={true}
      data-selectable={true}
      style={style}
    >
      <BrandThemeManager className={`#${id} .cs_text_widget`} themes={widgetProps.themes} />
      <WidgetsContext.Provider value={widgetContextState}>
        {widgetChildren.map(item => {
          return <Widget key={item.uid} widgetProps={item} breakpoint={breakpoint}  />
        })}
      </WidgetsContext.Provider>
    </div>
  )
}


const liveElementWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const LiveElementWidget = React.memo(LiveElementWidgetComponent, liveElementWidgetEquals);